import { render, staticRenderFns } from "./InspectionQuizStatusBadge.vue?vue&type=template&id=2dc78752&scoped=true"
import script from "./InspectionQuizStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionQuizStatusBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionQuizStatusBadge.vue?vue&type=style&index=0&id=2dc78752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc78752",
  null
  
)

export default component.exports